<template>
  <div
    class="g-gantt-row"
    ref="g-gantt-row"
    :style="{height: `${$parent.rowHeight}px`}"
  >
    <div
      class="g-gantt-row-label"
      :style="rowLabelStyle"
    >
      <slot name="label">
        {{label}}
      </slot>
    </div>
    <div
      class="g-gantt-row-bars-container"
      ref="barContainer"
      :style="barsContainerStyle"
      @mouseover="onMouseover()"
      @mouseleave="onMouseleave()"
    >
      <template v-if="isShow">
        <g-gantt-bar
          v-for="(bar, index) in barsInChatRange"
          :key="`ganttastic_bar_${index}`"
          :bar="bar"
          ref="ganttBar"
          :bar-start="barStart"
          :bar-end="barEnd"
          :bar-container="barContainer"
          :all-bars-in-row="bars"
        >
          <template #bar-label="{bar}">
            <slot
              name="bar-label"
              :bar="bar"
            />
          </template>
          <template #bar-edit-button="{bar}">
            <slot
            name="bar-edit-button"
            :bar="bar"
            />
          </template>
        </g-gantt-bar>
      </template>
    </div>
  </div>
</template>

<script>
import GGanttBar from './GGanttBar.vue'

export default {

  name: "GGanttRow",

  components:{
    GGanttBar
  },

  props:{
    label: {type: String, default: "Row"},
    bars: {type: Array, default: () => []},
    barStart: {type: String, required: true}, // property name of the bar objects that represents the start datetime
    barEnd: {type: String, required: true},  // property name of the bar objects that represents the end datetime,
    highlightOnHover: Boolean,
  },

  inject: ["ganttChartProps", "getThemeColors", "getChartStart", "getChartEnd"],

  data(){
    return {
      barContainer: {},
      isShow: false
    }
  },

  computed:{

    barsInChatRange() {
        return this.bars.filter(bar => moment(bar.start_date).isSameOrAfter(this.getChartStart()) && moment(bar.end_date).isSameOrBefore(this.getChartEnd()))
    },

    rowLabelStyle(){
      return {
        width: `${this.ganttChartProps.rowLabelWidth}px`,
        height: this.ganttChartProps.rowHeight,
        background: 'white',
        color: '#a7a7a7',
      }
    },

    barsContainerStyle(){
      return{
        width: `${Number(this.$parent.style.width.replace('px', '')) - this.ganttChartProps.rowLabelWidth}px`
      }
    },

  },

  mounted(){
    // Need wait until sidebar is lodaded for geting correct this.$refs.barContainer.getBoundingClientRect()
    // 100 just random number that is more than minimum first painted sidebar width and less needed 250px
    // as it is now
    let interval = setTimeout(() => {
        console.log('resize')
      if(document.querySelector('.sidenav.navbar').offsetWidth > 100){
        this.onWindowResize()
        clearTimeout(interval)
      }
    }, 200)

    document.getElementById('g-gantt-chart').addEventListener("resize", this.onWindowResize)
    document.getElementById('g-gantt-chart').addEventListener("scroll", this.onWindowResize)
  },

  methods:{
    onMouseover(){
      if(this.highlightOnHover){
        this.$refs["g-gantt-row"].style.backgroundColor = this.getThemeColors().hoverHighlight
      }
    },

    onMouseleave(){
      this.$refs["g-gantt-row"].style.backgroundColor = null
    },

    onWindowResize(){
      // re-initialize the barContainer DOMRect variable, which will trigger re-rendering in the gantt bars
      let resizeInterval = setTimeout(() => {
          console.log('res')
        if(this.$refs.barContainer){
          this.barContainer = this.$refs.barContainer.getBoundingClientRect()
          this.barContainer.width = Math.ceil(this.$moment(this.ganttChartProps.chartEnd).diff(this.ganttChartProps.chartStart, this.ganttChartProps.scaleName, true)) * this.ganttChartProps.scaleSize
          this.isShow = true
          clearTimeout(resizeInterval)
        }
      }, 200)
    }
  },

  watch:{
    'ganttChartProps.rowLabelWidth' : function(){
      this.onWindowResize()
    },
    'ganttChartProps.chartStart': function(){
      this.onWindowResize()
    },
    'ganttChartProps.chartEnd': function(){
      this.onWindowResize()
    },
    'ganttChartProps.scaleSize': function(){
      this.onWindowResize()
    }
  }
}
</script>

<style scoped>
  .g-gantt-row{
    display: flex;
    width: 100%;
    height: 60px;
    transition: background-color 0.2s;
  }

  .g-gantt-row > .g-gantt-row-label{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 20%;
    background: white;
    color: #a7a7a7;
    font-size: 0.9em;
    z-index: 4;
    overflow: hidden;
    font-weight: bold;
    padding-left: 20px;
    border: 1px solid #f4f5f8;
    position: sticky;
    left: 0;
  }

  .g-gantt-row > .g-gantt-row-bars-container{
    position: relative;
    border: 1px solid #f4f5f8;
    width: 100%;

  }

</style>
